import {DisplayAd, DisplayAdItem, ItemType} from '../generated/types';

export function createDisplayAdItem(displayAd: DisplayAd): DisplayAdItem {
  const id = `da-${displayAd.sectionUid}-${displayAd.momentUid}-${displayAd.treviUid}-${displayAd.bannerUid}`;
  return {
    id,
    displayAd,
    type: ItemType.Da,
  };
}
